import { render } from "./Tem022.vue?vue&type=template&id=336257b1&scoped=true"
import script from "./Tem022.vue?vue&type=script&lang=js"
export * from "./Tem022.vue?vue&type=script&lang=js"

import "./Tem022.vue?vue&type=style&index=0&id=336257b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336257b1"]])

export default __exports__